import axios from "axios";
import router from "@/redworks/routes/index";
import store from "@/redworks/stores/index";
import { RX_PAGE } from "@/redworks/js/consts/rx-const";
import { AUTH_PATH, AUTH_RST_CD } from "@/redworks/api/auth";
import i18n from "@/redworks/plugins/i18n";
import qs from "qs";

let isLoginRequired = false;
let showLoginDialog = null;
let waitForLogin = null;
/**
 * Axios 설정
 */
// 인증필요 없는 요청 시
const $axios = function createInstance() {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
};

function $axiosWithAuth() {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return setInterceptor(instance);
}

export const apiNa = $axios();
export const api = $axiosWithAuth();


/**
 * // 요청 인터셉터 처리
 * @param {*} instance
 */
function setInterceptor(instance) {
  // 요청 request 인터셉터
  setInterceptorRequest(instance);
  setInterceptorResponse(instance);
  return instance;
}

/**
 * 요청 request 인터셉트 설정
 */
function setInterceptorRequest(instance) {
  instance.interceptors.request.use(
    (config) => {
      config.headers.authorization = store.getters["auth/getAccessToken"];
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}


let isTokenRefreshing = false; // refresh발행중 여부
let requestsForRefreshing = []; // refresh발행중 요청 콜백 목록 저장

const callWaitRequests = () => {
  let accessToken = store.getters["auth/getAccessToken"];
  requestsForRefreshing.map((callback) => callback(accessToken));
};

const addRequestForRefreshing = (callback) => {
  requestsForRefreshing.push(callback);
};

/**
 * 응답 response 인터셉트 설정
 */
function setInterceptorResponse(instance) {
  const NON_PERMISSION_EXTENTION = 403;
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const {
        config,
        response: { status },
      } = error;

      //응답 후 403 에러 발생 시
      if (NON_PERMISSION_EXTENTION === status) {
        store.dispatch("app/setSnackbar", {
          show: true,
          y: "bottom",
          type: "error",
          color: "error",
          text: "권한이 없습니다."
        });
      }
      const originalRequest = config;
      const UNSUPPORTED_UPLOAD_EXTENTION = '415-1';

      // 응답 후 401 에러 발생 시  리프레시 토큰으로 인증토큰 재발행
      // 인증이 완전 만료 된 경우 인증정보 삭제 후 로그인 폼으로 이동.
      // 401 인증 오류인 경우에는 리프레시 호출
      if (AUTH_RST_CD.UNAUTHORIZED === status) {
        if (!isTokenRefreshing) {
          // 1. 리프레시 요청 중으로 값 변경
          isTokenRefreshing = true;
          // 2. 리프레시 토큰 취득
          let refreshToken = store.getters["auth/getRefreshToken"];
          let refreshConfig = {
            headers: {
              Authorization: refreshToken,
            },
          };
          try {
            // 사용처 로그인 구분 추가
            let refreshToken = store.getters["auth/getTokenType"];
            const reIssuePath = refreshToken === 'redworks' ? AUTH_PATH.REISSUE : AUTH_PATH.USEPLC_REISSUE;
            const { data } = await apiNa.post(
              reIssuePath,
              null,
              refreshConfig
            );
            let authorization = data.result;
            store.dispatch("auth/setAuthorization", authorization);
            // 3. 리프레시 요청 완료로 값 변경
            isTokenRefreshing = false;
            // 4. 성공인 경우는 요청목록대상 건 실행
            originalRequest.headers.authorization =
              store.getters["auth/getAccessToken"];
            callWaitRequests();
            return await instance(originalRequest);
          } catch (reissueError) {
            this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
            if (reissueError.response.status === AUTH_RST_CD.UNAUTHORIZED) { // 재발급 실패
              // 요청 API가 로그아웃일 때
              if (originalRequest.url == AUTH_PATH.LOGOUT) {
                isTokenRefreshing = false;
                requestsForRefreshing = [];
                store.dispatch("auth/initAuthorization");
                router.push(RX_PAGE.LOGIN).catch(() => { });
                return Promise.reject(reissueError);
              }

              store.dispatch("app/setSnackbar", {
                show: true,
                y: "bottom",
                type: "warn",
                color: "warning",
                text: i18n.t("common.msg.session_is_expired"),
              });

              if (router.currentRoute.path != RX_PAGE.LOGIN) {
                // 로그인 페이지가 아니면 로그인 다이얼로그 오픈
                store.dispatch("auth/resetAuthorizationExceptFeatures");

                if (!isLoginRequired) {
                  isLoginRequired = true;
                  if (showLoginDialog) {
                    showLoginDialog();
                  }
                }

                // 로그인 완료 대기
                const { loginSuccess, callApi } = await waitForLogin();
                isLoginRequired = false;
                if (loginSuccess) {
                  isTokenRefreshing = false;
                  originalRequest.headers.authorization =
                    store.getters["auth/getAccessToken"];
                  if (callApi) {
                    callWaitRequests();
                    return await instance(originalRequest);
                  }
                }
                return Promise.reject(error);
              } else {
                // 로그인 폼 상태라면, init 필요
                store.dispatch("auth/initLoginForm", true);
              }
              return Promise.reject(reissueError);
            }else{
              //재발급 실패 시
              isTokenRefreshing = false;
              requestsForRefreshing = [];
              store.dispatch("auth/initAuthorization");
              router.push(RX_PAGE.LOGIN).catch(() => { });
              store.dispatch("app/setSnackbar", {
                show: true,
                y: "bottom",
                type: "error",
                color: "error",
                text: i18n.t("common.msg.session_is_expired"),
              });
              return Promise.reject(reissueError);
            }
            // else {
            /**
             * 주석처리 (2021.10.12) -> 이후 문제 없을 경우 삭제
             * 사유) originalRequest 실행 시 originalRequest의 에러로 인해 아래 에러 메세지를 올림
             * 해결) originalRequest 에러는 각 메서드에서 처리하도록 하고 여기서는 주석처리함 /
             *      대신 reissue가 AUTH_RST_CD.UNAUTHORIZED 외의 에러를 발생했을 때의 처리가 필요
             */
            // 예상치 못한 오류 발생
            // 재발급 실패
            // store.dispatch("app/setSnackbar", {
            //   show: true,
            //   y: "bottom",
            //   type: "error",
            //   color: "error",
            //   text: i18n.t("common.msg.unexpected_error"),
            // });
            // return Promise.reject(error);
            // }
          }
        }
        // token 재발급 되는 시간 동안에 refresh요청콜백목록 저장
        return new Promise((resolve) => {
          addRequestForRefreshing(() => {
            let accessToken = store.getters["auth/getAccessToken"];
            originalRequest.headers.authorization = accessToken;
            resolve(axios(originalRequest));
          });
        });
      } else if (error.response.data.messageCode == UNSUPPORTED_UPLOAD_EXTENTION) {
        store.dispatch("app/setSnackbar", {
          show: true,
          y: "bottom",
          type: "warn",
          color: "warning",
          text: i18n.t("common.msg.not_support_extention"),
        });

        return Promise.reject(error);
      } else {
        // 인증 관련 이외의 결과
        return Promise.reject(error);
      }
      // store.dispatch("auth/initAuthorization");
      // router.push(RX_PAGE.LOGIN).catch(() => {/**/});
      // return new Promise(() => {/**/});
    }
  );
  isTokenRefreshing = false;
  requestsForRefreshing = [];
  return instance;
}